const Holly = {
    init() {
        this.data = window.ProjectHolly.data;
        this.products = this.data.products.filter(Boolean);
        this.calendarVariantId = this.data.calendarVariantId;

        this.state = {
            mode: null,
            selections: {}
        };

        this.launchButton = document.getElementById('holly-launch');
        this.drawer = document.getElementById('holly-drawer');
        this.overlay = document.getElementById('holly-overlay');
        this.app = document.getElementById('holly-app');

        if (!this.launchButton || !this.drawer || !this.overlay || !this.app) {
            console.error('Project Holly: required elements missing');
            return;
        }

        this.bindEvents();
        console.log('Project Holly ready');
    },

    bindEvents() {
        this.launchButton.addEventListener('click', () => this.open());
        this.overlay.addEventListener('click', () => this.close());
    },

    open() {
        this.drawer.classList.add('open');
        this.overlay.classList.add('open');
        this.renderStartScreen();
    },

    close() {
        this.drawer.classList.remove('open');
        this.overlay.classList.remove('open');
    },

    renderHeader() {
        return `
            <div class="holly-header">
                <h2>Build Your Advent Calendar</h2>

                <button
                    id="holly-close"
                    class="holly-close-button"
                    type="button"
                    aria-label="Close builder">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
        `;
    },

    bindCloseButton() {
        const closeButton = document.getElementById('holly-close');

        if (closeButton) {
            closeButton.addEventListener('click', () => this.close());
        }
    },

    renderStartScreen() {
        this.app.innerHTML = `
            ${this.renderHeader()}

            <div class="holly-body">
                <div class="holly-intro">
                    <h3>Choose how you'd like to start</h3>
                    <p>Select a starting point for your calendar. You can review and change your choices before adding it to your basket.</p>
                </div>

                <button class="holly-start-card" type="button" data-mode="gold">
                    <span class="holly-start-card__icon">●</span>
                    <span class="holly-start-card__content">
                        <strong>All Gold</strong>
                        <small>Every jewellery piece will be pre-selected in Gold.</small>
                    </span>
                </button>

                <button class="holly-start-card" type="button" data-mode="silver">
                    <span class="holly-start-card__icon">○</span>
                    <span class="holly-start-card__content">
                        <strong>All Silver</strong>
                        <small>Every jewellery piece will be pre-selected in Silver.</small>
                    </span>
                </button>

                <button class="holly-start-card" type="button" data-mode="mixed">
                    <span class="holly-start-card__icon">✦</span>
                    <span class="holly-start-card__content">
                        <strong>I'll Choose Each Piece</strong>
                        <small>Pick the colour, initials and sizes for every item yourself.</small>
                    </span>
                </button>
            </div>
        `;

        this.bindCloseButton();

        document.querySelectorAll('.holly-start-card').forEach((button) => {
            button.addEventListener('click', () => {
                this.startBuilder(button.dataset.mode);
            });
        });
    },

    startBuilder(mode) {
        this.state.mode = mode;
        this.state.selections = {};

        this.products.forEach((product, index) => {
            const day = index + 1;
            this.state.selections[day] = {};

            product.options.forEach((optionName) => {
                const values = this.getOptionValues(product, optionName);

                if (optionName.toLowerCase() === 'colour') {
                    if (mode === 'gold') {
                        this.state.selections[day][optionName] = this.findOptionValue(values, 'gold');
                    } else if (mode === 'silver') {
                        this.state.selections[day][optionName] = this.findOptionValue(values, 'silver');
                    } else {
                        this.state.selections[day][optionName] = null;
                    }
                } else {
                    this.state.selections[day][optionName] = values[0] || null;
                }
            });
        });

        this.renderProductList();
    },

    findOptionValue(values, search) {
        return values.find((value) =>
            String(value).toLowerCase().includes(search)
        ) || null;
    },

    getOptionValues(product, optionName) {
        const optionIndex = product.options.indexOf(optionName);

        if (optionIndex === -1) return [];

        const key = `option${optionIndex + 1}`;
        const values = product.variants
            .map((variant) => variant[key])
            .filter(Boolean);

        return [...new Set(values)];
    },

    getSelectedVariant(product, selections) {
        return product.variants.find((variant) => {
            return product.options.every((optionName, index) => {
                const key = `option${index + 1}`;
                return variant[key] === selections[optionName];
            });
        }) || null;
    },

    getProductImage(product, variant) {
        if (variant && variant.featured_image && variant.featured_image.src) {
            return variant.featured_image.src;
        }

        if (product.featured_image) {
            return product.featured_image;
        }

        return '';
    },

    renderProductList(scrollPosition = null) {
        const cards = this.products.map((product, index) => {
            return this.renderProductCard(product, index + 1);
        }).join('');

        const complete = this.isComplete();

        this.app.innerHTML = `
            ${this.renderHeader()}

            <div class="holly-body">
                <button class="holly-back" type="button">← Back</button>

                <div class="holly-progress">
                    <strong>${this.getCompletedCount()} of ${this.products.length} complete</strong>

                    <div class="holly-progress-bar">
                        <span style="width:${this.getProgressPercentage()}%"></span>
                    </div>
                </div>

                <div class="holly-products">
                    ${cards}
                </div>
            </div>

            <div class="holly-footer">
                <button
                    id="holly-add-to-cart"
                    class="holly-add-to-cart"
                    type="button"
                    ${complete ? '' : 'disabled'}>
                    ${complete ? 'Add Calendar to Basket' : 'Complete Your Calendar'}
                </button>
            </div>
        `;

        this.bindCloseButton();

        const body = this.app.querySelector('.holly-body');

        /*
         * When an option change causes the builder to re-render,
         * restore the customer's previous scroll position.
         */
        if (body && scrollPosition !== null) {
            body.scrollTop = scrollPosition;

            requestAnimationFrame(() => {
                body.scrollTop = scrollPosition;
            });
        }

        const backButton = this.app.querySelector('.holly-back');

        if (backButton) {
            backButton.addEventListener('click', () => {
                this.renderStartScreen();
            });
        }

        this.app.querySelectorAll('[data-holly-option]').forEach((input) => {
            input.addEventListener('change', () => {
                const currentBody = this.app.querySelector('.holly-body');
                const currentScrollPosition = currentBody
                    ? currentBody.scrollTop
                    : 0;

                const day = input.dataset.day;
                const option = input.dataset.option;

                this.state.selections[day][option] = input.value;

                this.renderProductList(currentScrollPosition);
            });
        });

        const addButton = document.getElementById('holly-add-to-cart');

        if (addButton && complete) {
            addButton.addEventListener('click', () => this.addToCart());
        }
    },

    renderProductCard(product, day) {
        const selections = this.state.selections[day] || {};
        const variant = this.getSelectedVariant(product, selections);
        const image = this.getProductImage(product, variant);

        /*
         * Day 7 is the fixed £50 physical gift card.
         * There is no customer selection required.
         */
        const isFixedGiftCard = day === 7;

        let optionControls = '';

        if (isFixedGiftCard) {
            optionControls = `
                <div class="holly-option-group holly-fixed-gift-card">
                    <p class="holly-option-label">£50 Gift Card Included</p>

                    <p class="holly-fixed-gift-card__text">
                        Your £50 gift card is automatically included in your Advent Calendar.
                    </p>
                </div>
            `;
        } else {
            optionControls = product.options.map((optionName) => {
                const values = this.getOptionValues(product, optionName);

                if (optionName.toLowerCase() === 'colour') {
                    return `
                        <div class="holly-option-group">
                            <p class="holly-option-label">${optionName}</p>

                            <div class="holly-colour-options">
                                ${values.map((value) => `
                                    <label class="holly-colour-pill">
                                        <input
                                            type="radio"
                                            name="day-${day}-${optionName}"
                                            value="${value}"
                                            data-day="${day}"
                                            data-option="${optionName}"
                                            data-holly-option
                                            ${selections[optionName] === value ? 'checked' : ''}
                                        >
                                        <span>${value}</span>
                                    </label>
                                `).join('')}
                            </div>
                        </div>
                    `;
                }

                return `
                    <div class="holly-option-group">
                        <label
                            class="holly-option-label"
                            for="day-${day}-${optionName}">
                            ${optionName}
                        </label>

                        <select
                            id="day-${day}-${optionName}"
                            data-day="${day}"
                            data-option="${optionName}"
                            data-holly-option>

                            ${values.map((value) => `
                                <option
                                    value="${value}"
                                    ${selections[optionName] === value ? 'selected' : ''}>
                                    ${value}
                                </option>
                            `).join('')}

                        </select>
                    </div>
                `;
            }).join('');
        }

        return `
            <div class="holly-product-card">
                <div class="holly-product-card__image">
                    ${image ? `<img src="${image}" alt="${product.title}">` : ''}
                </div>

                <div class="holly-product-card__content">
                    <p class="holly-day">Day ${day}</p>
                    <h3>${product.title}</h3>
                    ${optionControls}
                </div>
            </div>
        `;
    },

    getCompletedCount() {
        return this.products.filter((product, index) => {
            const day = index + 1;
            const selections = this.state.selections[day] || {};

            return product.options.every(
                (optionName) => selections[optionName]
            );
        }).length;
    },

    getProgressPercentage() {
        return (
            this.getCompletedCount() /
            this.products.length
        ) * 100;
    },

    isComplete() {
        return this.getCompletedCount() === this.products.length;
    },

    getSelectionSummary(product, selections) {
        return product.options
            .map((optionName) => selections[optionName])
            .filter(Boolean)
            .join(' / ');
    },

       buildCartProperties() {
        const properties = {
            'Calendar Type': 'Personalised Advent Calendar'
        };

        this.products.forEach((product, index) => {
            const day = index + 1;
            const selections = this.state.selections[day];

            const summary = this.getSelectionSummary(
                product,
                selections
            );

            /*
             * Day 7 is fixed, so don't show "Default Title"
             * to the customer in the calendar summary.
             */
            if (day === 7) {
                properties[`Day ${day}`] =
                    `${product.title} - £50 Gift Card Included`;
            } else {
                properties[`Day ${day}`] =
                    `${product.title} - ${summary}`;
            }
        });

        return properties;
    },

   addToCart() {
    if (!this.isComplete()) return;

    const addButton = document.getElementById('holly-add-to-cart');

    if (!addButton) return;

    addButton.disabled = true;
    addButton.textContent = 'Adding...';

    const bundleId =
        'advent-' +
        Date.now() +
        '-' +
        Math.random().toString(36).substring(2, 10);

    const parentProperties = this.buildCartProperties();

    parentProperties['_Advent Bundle ID'] = bundleId;

    const items = [
        {
            id: this.calendarVariantId,
            quantity: 1,
            properties: parentProperties
        }
    ];

    for (let index = 0; index < this.products.length; index++) {
        const product = this.products[index];
        const day = index + 1;
        const selections = this.state.selections[day] || {};

        const variant = this.getSelectedVariant(
            product,
            selections
        );

        if (!variant) {
            console.error(
                `Project Holly: unable to find selected variant for Day ${day}.`
            );

            addButton.disabled = false;
            addButton.textContent = 'Add Calendar to Basket';

            alert(
                `Please check your selection for Day ${day} before adding your calendar to the basket.`
            );

            return;
        }

        items.push({
            id: variant.id,
            quantity: 1,
            properties: {
                '_Advent Component': 'true',
                '_Advent Bundle ID': bundleId,
                '_Advent Day': String(day)
            }
        });
    }

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            items: items
        })
    })
        .then(async (response) => {
            if (!response.ok) {
                let message =
                    'Unable to add Advent Calendar to basket.';

                try {
                    const errorData = await response.json();

                    if (errorData && errorData.description) {
                        message = errorData.description;
                    }
                } catch (error) {
                    // Use standard error message.
                }

                throw new Error(message);
            }

            return response.json();
        })

        .then(() => {
            addButton.textContent = 'Added to Basket';

            setTimeout(() => {
                window.location.href = '/cart';
            }, 500);
        })

        .catch((error) => {
            console.error('Project Holly:', error);

            addButton.disabled = false;
            addButton.textContent = 'Add Calendar to Basket';

            alert(
                'Sorry, we could not add your Advent Calendar to the basket. ' +
                'One of your selected pieces may no longer be available. ' +
                'Please review your selections and try again.'
            );
        });
}
};

document.addEventListener('DOMContentLoaded', () => {
    Holly.init();
});

document.addEventListener('click', function(event) {
    const adventButton = event.target.closest('a[href="#build-advent-calendar"]');

    if (!adventButton) return;

    event.preventDefault();

    const originalAdventButton = document.getElementById('holly-launch');

    if (originalAdventButton) {
        originalAdventButton.click();
    }
});

/* Move Advent drawer outside Shopify section stacking contexts */
(function () {
    function moveAdventBuilderToBody() {
        const overlay = document.getElementById('holly-overlay');
        const drawer = document.getElementById('holly-drawer');

        if (overlay && overlay.parentElement !== document.body) {
            document.body.appendChild(overlay);
        }

        if (drawer && drawer.parentElement !== document.body) {
            document.body.appendChild(drawer);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', moveAdventBuilderToBody);
    } else {
        moveAdventBuilderToBody();
    }
})();